import { render, staticRenderFns } from "./OrderEntitiesDetails.vue?vue&type=template&id=2adf8c77"
import script from "./OrderEntitiesDetails.vue?vue&type=script&lang=js"
export * from "./OrderEntitiesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports